import {fpPromise} from "@/service/config";
import {datetimeOptions} from "@/service/options";

export default function getImageURI(URI) {
    return require("'" + URI + "'");
}

export async function generateFingerPrint() {
    const fp = await fpPromise
    const result = await fp.get()
    return result.visitorId
}

export function validateEmail(email) {
    // return true if email is valid; return false if email is not valid
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

export function isEmpty(obj) {
    if (!obj) return true;
    return Object.keys(obj).length === 0;
}

export function isStringEmpty(str) {
    return str === null || str === undefined
}

export function apiDateTimeToJsDate(dateTime) {
    if (!dateTime) return null;
    const date = new Date(dateTime);
    return date.toLocaleDateString("ru", datetimeOptions)
}